/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

app.controller('dialog_acceptUserDeletionCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'IntentService', function ($rootScope, $scope, $http, NetworkService, MainService, IntentService) {
        
        $rootScope.$on("render_dialog_acceptUserDeletionCtrl", function(e,usr){
            $scope.usr = usr;
            $("#dialog_acceptUserDeletion").show()
        })
        $scope.delete = function()
        {
            var schicht_id = $scope.usr.schicht_id;
            var position_id = $scope.usr.position_id;
            var email = $scope.usr.email;
             NetworkService.removeUserFromSchicht(schicht_id, position_id, email, function () {
                $scope.success("Nutzer erfolgreich von Schicht entfernt");
                $rootScope.$emit("repaint")
            });
            $("#dialog_acceptUserDeletion").hide()
        }
    }])
